import { Footer } from 'mm-ui-components';
import { connect } from 'react-redux';
import {
  getAppsSection,
  getBottomFooterBar,
  getLinksSection,
  getSocialSection,
} from '../../store/footer/footer.selectors';
import { AppState } from '../../store/initialStateRegistration';

export const mapStateToProps = (state:AppState) => {
  return {
    linksSection: getLinksSection(state),
    socialSection: getSocialSection(state),
    appsSection: getAppsSection(state),
    bottomFooterBar: getBottomFooterBar(state),
  };
};

export const FooterConnected = connect(mapStateToProps)(Footer);
